<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row">
          <div class="col-lg-6 m-b-10 d-flex">
            <div class="card text-center h-100 welcome">
              <div class="card-header"></div>
              <div class="card-body">
                <div class="questiondescription padding-50">
                  <img src="../../assets/img/2424FIT-lightbulb.svg" alt="hoe-was-je-dienst" height="130px">
                  <p class="bigbold text-white p-t-25">{{ $t('survey_start_text1') }}</p>
                </div>
                <div class="m-b-50">
                  <p class="text-white">{{ $t('survey_start_text2') }} </br>
                    <span class="bold">{{ survey.RoundName }}</span>
                  </p>
                </div>
                <div class="btn-group btn-group-justified w-100">
                  <button class="nextbutton text-24 bg-white"
                          @click="$emit('start-survey')">
                    {{ $t('survey_start') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['survey'],
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/surveys/SurveyStart.vue